import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from "react-router-dom";
function PaidCustomer() {
    const [loading, setLoading] = useState(true);
    const [stbCount, setStbCount] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);
    const [networkName, setNetworkName] = useState([]);
    const [streetName, setStreetName] = useState([]);
    const [staffCode, setStaffCode] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "ascending" });
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const user = getCookie('user');
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ area_code: "", network: "", date: "", toDate: "" })
    const initialFormData = { area_code: "", network: "", date: "", toDate: "" }
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/'); }
    function handleChange(e) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
 const downloadCSV = () => {

  let headers = [
    "Sno", "Customer_Name", "Acc_no", "Code", "STB_no", "Door_no", "Flat_name",
    "Street_name", "Phone", "Pay_Status", "Plan_Amount", "Paid_Amount", "Paid_Date",
    "Balance_Amount", "Discount_Amount", "Advance_Amount", "Pending_Amount",
    "Staff_Code", "Network", "Paid_time", "Package", "Added_date", "Collection_Staff"
  ];

  // ✅ Add extra headers
  if (user === "srcv1") {
    headers.push("Payment Mode", "Chequee Number/Remarks", "Payment For");
  }

  const csvRows = [];
  csvRows.push(headers.join(","));

  allCustomer.forEach((row, index) => {

    let values = [
      index + 1,
      row.name,
      row.account_num,
      row.acc_num,
      row.serial_num,
      row.doorno,
      row.flat_name,
      row.street,
      row.mobile,
      row.status,
      row.pay_amt,
      row.paid_amt,
      row.paid_date,
      row.balance_amt,
      row.discount,
      row.extra_balance_amt,
      row.pend_amt,
      row.area_code,
      row.net_name,
      row.paid_time,
      row.package,
      row.adate,
      row.col_boy
    ];

    // ✅ Add extra values
    if (user === "srcv1") {
      values.push(
        row.payment_mode || "",
        row.cheque_no || row.remarks || "",
        row.payment_for || ""
      );
    }

    const safeValues = values.map(v => {
      const str = v == null ? "" : String(v).replace(/"/g, '""');
      return `"${str}"`;
    });

    csvRows.push(safeValues.join(","));
  });

  const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "paidCustomers.csv";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

   // 1. FILTER FIRST
const filteredRows = allCustomer.filter((row) =>
  Object.values(row).some(value =>
    String(value).toLowerCase().includes(searchQuery.toLowerCase())
  )
);

// 2. TOTALS FROM ALL FILTERED ROWS
const totalPayAmt = filteredRows.reduce((s, r) => s + Number(r.pay_amt || 0), 0);
const totalPaidAmt = filteredRows.reduce((s, r) => s + Number(r.paid_amt || 0), 0);
const totalBalanceAmt = filteredRows.reduce((s, r) => s + Number(r.balance_amt || 0), 0);
const totalDiscountAmt = filteredRows.reduce((s, r) => s + Number(r.discount || 0), 0);
const totalAdvanceAmt = filteredRows.reduce((s, r) => s + Number(r.extra_balance_amt || 0), 0);
const totalPendingAmt = filteredRows.reduce((s, r) => s + Number(r.pend_amt || 0), 0);

// 3. PAGINATE FILTERED DATA ONLY
const indexOfLastRow = currentPage * rowsPerPage;
const indexOfFirstRow = indexOfLastRow - rowsPerPage;
const currentRows = filteredRows.slice(indexOfFirstRow, indexOfLastRow);

// 4. TOTAL PAGES FOR FILTERED DATA
const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

// 5. Pagination function
const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleClear = () => { setFormData(initialFormData); }; 
    function handleSubmit(e) {
        setIsButtonDisabled(true);
        e.preventDefault();
        console.log("Form Data:", formData); a();
        async function a() {
            try {
                const response = await axios.post('https://node.cabletvpay.in/paidCustomerSpecific', { user, formData });
                if (response.status === 200) {
                    console.log(response.data.result);
                    setStbCount(response.data.result.length);
                    setAllCustomer(response.data.result);
                    setIsButtonDisabled(false);
                }
            } catch (err) {
                toast.error(err.response?.data?.message || "Error fetching data");
                setIsButtonDisabled(false)
            }
        }
    }
    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/paidCustomerGetInfo', { user });
            if (response.status === 200) {
                setNetworkName(response.data.net_name);
                setStbCount(response.data.allCustomer.length);
                setStaffCode(response.data.staffCode);
                setStreetName(response.data.streetDetails);
                setAllCustomer(response.data.allCustomer);
            }
        } catch (err) { setError(err.response?.data?.message || "Error fetching data"); }
        finally { setLoading(false); }
    };
  

    const stb = useMemo(() => allCustomer.map(row => parseInt(row.serial_num, 10)), [allCustomer]);
    const handleCopyToClipboard = () => { navigator.clipboard.writeText(stb).then(() => { toast.info(`${stbCount} STB numbers copied`); }).catch((error) => { toast.warning("not copied: " + error); }); };
    useEffect(() => { fetchUserData(); }, []);
    if (loading) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass="" />
        </div></div>)
    if (error) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>
            <img src="../asset/img/errorPage.jpg" alt="" style={{ height: "20rem" }} />
        </div></div>);
    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <h5 className='h5'>PAID CUSTOMER DETAILS</h5><hr className='mt-0' />
                <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
                <div className="border-0 px-1">
                    <form method="get" onSubmit={handleSubmit}>
                        <div className="row mx-3  d-flex justify-content-center">
                            <div className="col-lg-3 col-md-6 col-12 mb-2">
                                <div className="form-group">
                                    <label htmlFor="area_code" className="text-center valuesDec text-navy">Staff Code</label>
                                    <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="area_code" name="area_code" value={formData.area_code} onChange={handleChange}>
                                        <option className='bg-light' value="">none</option>
                                        {staffCode.length > 0 ? (staffCode.map((row, index) => (
                                            <option className='bg-light' key={index} value={row.name + "-" + row.staffCode}>
                                                {row.name} - ({row.staffCode})
                                            </option>
                                        ))) : (<option className='bg-light' value="">No staff codes available</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-12 mb-2">
                                <div className="form-group">
                                    <label htmlFor="network" className="text-center valuesDec text-navy">Network Name</label>
                                    <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="network" name="network" value={formData.network} onChange={handleChange}>
                                        <option className='bg-light' value="none">none</option>
                                        {networkName.length > 0 ? (networkName.map((row, index) => (
                                            <option className='bg-light' key={index} value={row.network}>
                                                {row.network}
                                            </option>
                                        ))) : (<option className='bg-light' value="">No staff codes available</option>)}
                                    </select>
                                </div></div>
                            <div className="col-lg-3 col-md-6 col-12 mb-2">
                                <div className="form-group">
                                    <label htmlFor="date" className="text-center valuesDec text-navy">Date</label>
                                    <input type="date" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="date" id="date" value={formData.date} onChange={handleChange} />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-12 mb-2">
                                <div className="form-group">
                                    <label htmlFor="toDate" className="text-center valuesDec text-navy">To</label>
                                    <input type="date" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="toDate" id="toDate" value={formData.toDate} onChange={handleChange} />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-6 mb-2 d-flex justify-content-center">
                                <input type="submit" className="btn border-0  bg-info filterBtn text-light pb-3 pb-lg-1 w-100" disabled={isButtonDisabled} value="Filter" />
                            </div>
                            <div className="col-lg-1 col-md-3 col-6 mb-2 d-flex justify-content-center">
                                <button type="button" className="btn border-0 bg-danger filterBtn text-light  pb-3 pb-lg-1 w-100" onClick={handleClear} > Clear </button>
                            </div>
                        </div>
                    </form>
                    
                </div>
                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h4 className="pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                                </div>
                            </div>
                            <div className="col-lg-8 mt-1">
                                <span><div className="row w-auto">
                                    <div className="col-11 col-lg-6">
                                        <div className="input-group">
                                            <input type="text" className="form-control text-navy bg-light border-0 px-1 py-0" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ borderRadius: "5px 0 0 5px" }} />
                                            <span className="input-group-text bg-light text-navy border-0 px-2" id="basic-addon1" style={{ borderRadius: "0 5px 5px 0" }} > <i className="fas fa-search" /> </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                        <div className="d-flex justify-content-end">
                                            <div className=" btn-group">
                                                <button onClick={downloadCSV} className="btn btn-dark border-right px-lg-3 px-5 my-1 d-flex"><i className="fas fa-download pt-1 px-1" /> Download</button>
                                                <button type="button" className="btn btn-dark border-left px-lg-3 px-5 my-1 d-flex" data-toggle="modal" onClick={handleCopyToClipboard} data-target="#exampleModal"> <i className="far fa-copy pt-1 px-1" /> STBCOPY-{stbCount} </button>
                                            </div>
                                        </div>
                                    </div>
                                </div></span>
                            </div>
                        </div>
                    </div>
                   <div className="card-body p-0 bg-light">
                    <table id="myTable" className="table table-bordered  table-responsive">
                    <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Sl_No</th>
                                    <th>Customer__Name</th>
                                   
                                    <th>Acc_no</th>
                                    <th>Code</th>
                                    <th>STB_no</th>
                                    <th>D_no</th>
                                    <th>Flat_name</th>
                                    <th>Street__name</th>
                                    <th>Phone</th>
                                    <th>Pay Status</th>
                                     <th>Plan Amount</th>
                                    <th>Paid Amount</th>
                                    <th>Paid__Date</th>
                                    <th>Paid_Time</th>
                                    <th>Balance Amount</th>
                                    <th>Discount Amount</th>
                                    <th>Advance Amount</th>
                                    <th>Pending Amount</th>
                                    {user === "srcv1" && (
                                        <>
                                            <th>Payment Mode</th>
                                            <th>Chequee Number/Remarks</th>
                                            <th>Payment For</th>
                                        </>
                                    )}

                                    <th>Staff__Code</th>
                                    <th>Networks</th>
                                    <th>Collection_Staff</th>
                                    
                                </tr>
                            </thead>
                           <tbody>
      {currentRows.length > 0 ? (
        <>
            {currentRows.map((row, index) => (
                <tr key={index} className='text-dark'>
                    <td className='tableText'>{indexOfFirstRow + index + 1}</td>
                    <td className='tableText border-dark text-bold'>{row.name}</td>
                    <td className='tableText border-dark text-bold'>{row.account_num}</td>
                    <td className='tableText border-dark text-bold'>{row.acc_num}</td>
                    <td className='tableText border-dark text-bold'>{row.serial_num}</td>
                    <td className='tableText border-dark text-bold'>{row.doorno}</td>
                    <td className='tableText border-dark text-bold'>{row.flat_name}</td>
                    <td className='tableText border-dark text-bold'>{row.street}</td>
                    <td className='tableText border-dark text-bold'>{row.mobile}</td>
                    <td className='tableText border-dark text-bold'>{row.status}</td>
                    <td className='tableText border-dark text-bold'>{row.pay_amt}</td>
                    <td className='tableText border-dark text-bold'>{row.paid_amt}</td>
                    <td className='tableText border-dark text-bold'>{row.paid_date}</td>
                    <td className='tableText border-dark text-bold'>{row.paid_time}</td>
                    <td className='tableText border-dark text-bold'>{row.balance_amt}</td>
                    <td className='tableText border-dark text-bold'>{row.discount}</td>
                    <td className='tableText border-dark text-bold'>{row.extra_balance_amt}</td>
                    <td className='tableText border-dark text-bold'>{row.pend_amt}</td>

                    {user === "srcv1" && (
                        <>
                            <td className='tableText'>{row.payment_mode}</td>
                            <td className='tableText'>{row.cheque_no}</td>
                            <td className='tableText'>{row.payment_for}</td>
                        </>
                    )}

                    <td className='tableText border-dark text-bold'>{row.area_code}</td>
                    <td className='tableText border-dark text-bold'>{row.net_name}</td>
                    <td className='tableText border-dark text-bold'>{row.col_boy}</td>
                </tr>
            ))}

       {/* ---------------------- TOTAL ROW ---------------------- */}
<tr className="fw-bold">
    {/* Total Label */}
    <td className="tableText border-dark text-bold text-bold">Total :</td>

    {/* Empty columns until Pay Amount column */}
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>

    {/* Pay Amount Total */}
    <td className="tableText border-dark text-bold text-bold">{totalPayAmt}</td>

    {/* Paid Amount Total */}
    <td className="tableText border-dark text-bold text-bold">{totalPaidAmt}</td>

    {/* Paid Date */}
    <td className="tableText border-dark text-bold"></td>

    {/* Paid Time */}
    <td className="tableText border-dark text-bold"></td>

    {/* Balance Amount */}
    <td className="tableText border-dark text-bold text-bold">{totalBalanceAmt}</td>

    {/* Discount */}
    <td className="tableText border-dark text-bold text-bold">{totalDiscountAmt}</td>

    {/* Advance (Extra) */}
    <td className="tableText border-dark text-bold text-bold">{totalAdvanceAmt}</td>

    {/* Pending */}
    <td className="tableText border-dark text-bold text-bold">{totalPendingAmt}</td>

    {/* Extra fields for srcv1 */}
    {user === "srcv1" && (
        <>
            <td className="tableText border-dark text-bold"></td>
            <td className="tableText border-dark text-bold"></td>
            <td className="tableText border-dark text-bold"></td>
        </>
    )}

    {/* Area, Net, Col Boy (empty) */}
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>
</tr>

        </>
    ) : (
        <tr>
            <td colSpan="20">No results found</td>
        </tr>
    )}
</tbody>

                        </table>
                    </div>
                    <div className="card-footer">
                        <div className="d-flex justify-content-end">
                            <div className="pagination btn-group border-dark text-bold">
                                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-dark text-bold active" : "btn-dark"} border-left`} > 1 </button>
                                {currentPage > 3 && <span className="mx-1">...</span>}
                                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                                    .filter((page) => page > 1 && page < totalPages)
                                    .map((page) => (
                                        <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-dark text-bold active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                                    ))}
                                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                                {totalPages > 1 && (
                                    <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-dark text-bold active" : "btn-dark"} border-right`} > {totalPages} </button>
                                )}
                                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
export default PaidCustomer;
